<h2 mat-dialog-title>Pend until…</h2>
<hr>

<div mat-dialog-content>
    <div class="pend-form">
        <!-- Native date + time pickers — mobile devices show their own
             friendly wheel/calendar UI; one control, no dead dependencies. -->
        <label class="pend-field">
            <span class="pend-label">Return date &amp; time</span>
            <input type="datetime-local" class="pend-datetime" [ngModel]="pendDateTimeLocal"
                (ngModelChange)="onDateTimeChange($event)" data-cy="pend-datetime" />
        </label>

        <div class="pend-quick">
            <button mat-stroked-button type="button" (click)="setPendingTimePlusThirtyMinutes()" data-cy="pend-plus-30m">+30 min</button>
            <button mat-stroked-button type="button" (click)="setPendingTimePlusOneHour()" data-cy="pend-plus-1h">+1 hour</button>
            <button mat-stroked-button type="button" (click)="setPendingTimePlusOneDay()" data-cy="pend-plus-1d">+1 day</button>
            <button mat-stroked-button type="button" (click)="setPendingTimeTomorrowMorning()" data-cy="pend-tomorrow">Tomorrow 9am</button>
        </div>

        <label class="pend-field">
            <span class="pend-label">Note (optional)</span>
            <textarea class="pend-note" [(ngModel)]="noteText" rows="3"
                placeholder="Leave a note for when this Particle returns from pending…"></textarea>
        </label>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined" data-cy="dialog-cancel">Cancel</button>
    <button mat-raised-button (click)="submit()" data-cy="dialog-confirm" color="primary">Pend</button>
</div>
